import { render, staticRenderFns } from "./ivr-summary.vue?vue&type=template&id=58c2e8c0&"
import script from "./ivr-summary.vue?vue&type=script&lang=js&"
export * from "./ivr-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports